import { motion } from 'framer-motion';
import { BellRing, Copy, Network, Send, Sparkles, Target } from 'lucide-react';

export function ProductMockup() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.25 }}
      className="relative mx-auto w-full max-w-4xl"
    >
      <div className="absolute inset-0 translate-x-4 translate-y-4 border-2 border-border bg-accent" />
      <motion.div
        whileHover={{ y: -4 }}
        transition={{ duration: 0.25 }}
        className="relative border-2 border-border bg-card p-5 shadow-[12px_12px_0px_hsl(var(--foreground))]"
      >
        <div className="mb-5 flex items-center justify-between border-b-2 border-border pb-4">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center border-2 border-border bg-primary text-primary-foreground">
              <Sparkles className="h-4 w-4" />
            </div>
            <div>
              <p className="font-black leading-none">beloud.pro</p>
              <p className="text-xs font-semibold text-muted-foreground">Persona workspace</p>
            </div>
          </div>
          <span className="border-2 border-border bg-accent px-2 py-1 text-xs font-black text-accent-foreground">LIVE SIGNALS</span>
        </div>

        <div className="grid gap-4 md:grid-cols-[0.85fr_1.15fr]">
          <div className="space-y-3">
            {[
              { icon: Target, label: 'Founder persona', value: 'AI automation consultant' },
              { icon: Network, label: 'People to impress', value: '18 tracked profiles' },
              { icon: BellRing, label: 'Alerts', value: '4 new posts today' },
            ].map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.label} className="border-2 border-border bg-muted/40 p-3">
                  <div className="mb-2 flex items-center gap-2 text-xs font-black uppercase tracking-[0.18em] text-muted-foreground">
                    <Icon className="h-4 w-4" />
                    {item.label}
                  </div>
                  <p className="font-bold">{item.value}</p>
                </div>
              );
            })}
          </div>

          <div className="border-2 border-border bg-background p-4">
            <div className="mb-3 flex items-center justify-between">
              <p className="font-black">AI Studio draft</p>
              <span className="text-xs font-semibold text-muted-foreground">EN · comment</span>
            </div>
            <p className="mb-4 text-sm leading-6 text-muted-foreground">
              Write a sharp comment for a LinkedIn post about AI replacing marketing teams. Tone: direct, useful, not corporate.
            </p>
            <div className="border-2 border-border bg-card p-4">
              <p className="text-sm leading-6">
                The real risk is not AI replacing the team. It is teams using AI to produce more average work, faster. The advantage goes to whoever combines taste, distribution and speed.
              </p>
              <div className="mt-4 flex flex-wrap gap-2 text-xs font-bold text-muted-foreground">
                <span>14 credits</span>
                <span>·</span>
                <span>copy-paste ready</span>
                <span>·</span>
                <span>manual publish</span>
              </div>
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <button className="inline-flex items-center gap-2 border-2 border-border px-3 py-2 text-sm font-bold">
                <Copy className="h-4 w-4" /> Copy
              </button>
              <button className="inline-flex items-center gap-2 border-2 border-border bg-primary px-3 py-2 text-sm font-bold text-primary-foreground">
                <Send className="h-4 w-4" /> Generate
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
